module.exports = __webpack_public_path__ + "img/water_colour_circle.ed984e14.png";